import { STATIC_URL } from 'constants/all';

export const IMAGES = {
  background: `${STATIC_URL}/images/help_background_art.png`,
  supportTeam: `${STATIC_URL}/images/support_team.png`,
} as const;
